<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.requestsType"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Prašymo tipas"
                  v-model="mainData['in_journal_type-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.requestStatus"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Prašymo būsena"
                  v-model="mainData['status-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Prašymo numeris"
                  v-model="mainData['request_number-search-like']"
                  hide-details
                  :maxlength="40"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Registro objekto ID"
                  v-model="mainData['mandate_code-search-like']"
                  hide-details
                  :maxlength="10"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Prašymo būsenos data nuo"
                  v-model="mainData['registration_date_from-search-custom']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="3" lg="3">
                <el-date-picker
                  label="Prašymo būsenos data iki"
                  v-model="mainData['registration_date_to-search-custom']"
                />
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Prokūrą išdavęs JA"
                  v-model="mainData['pro_principal_name-search-custom']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Prokūrą išdavęs JA kodas"
                  v-model="mainData['pro_principal_code-search-custom']"
                  hide-details
                  :cMask="9"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Prokuristas"
                  v-model="mainData['procurator_name-search-custom']"
                  hide-details
                  :maxlength="100"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Prokuristo asmens kodas"
                  v-model="mainData['procurator_code-search-custom']"
                  hide-details
                  :cMask="11"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="in-journals" :loading="loading" :reportData="reportData"  :listURL="'requests/list'" />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'PreparedSentRequestsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch(true)
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
